import {Injectable} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {CommunicationTerms, Term} from "../models/communication-terms";
import {BaseService} from "./base.service";
import {MatDialog} from "@angular/material/dialog";
import {User} from "../models/user";
import {ViewPrivacyDialogComponent} from "../dialogs/view-privacy-dialog/view-privacy-dialog.component";

@Injectable({
    providedIn: 'root'
})
export class CommunicationService extends BaseService {

    private API_COMMUNICATION_URL = this.API_BASE_URL + "communication";
    private API_USER_URL = this.API_BASE_URL + "management/user";

    constructor(
        private httpClient: HttpClient,
        private dialog: MatDialog
    ) {
        super();
    }

    getCommunicationTerms() {
        return this.httpClient.get<CommunicationTerms>(this.API_COMMUNICATION_URL + "/terms");
    }

    setCommunicationTerms(termIds: number[]) {
        return this.httpClient.put(this.API_COMMUNICATION_URL + "/terms?termsIds=" + termIds.toString(), null);
    }

    openTermsDialog(terms: Term[]) {
        return this.dialog.open(ViewPrivacyDialogComponent, {
            width: '600px',
            disableClose: true,
            data: {
                terms: terms
            }
        });
    }

    sendTempPassword(email: string) {
        return this.httpClient.post<any>(this.API_USER_URL + "/reset-temp-password", {
            username: email
        });
    }
}